var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIStarsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 191.497,
    height: 30,
    viewBox: "0 0 191.497 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34579",
    "data-name": "Group 34579",
    transform: "translate(0 -2380)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_25",
    "data-name": "Polygon 25",
    d: "M14.463,1.078a.6.6,0,0,1,1.074,0l4.128,8.289a.6.6,0,0,0,.432.323l8.82,1.575a.6.6,0,0,1,.334,1l-6.29,6.763a.6.6,0,0,0-.155.492l1.3,9.327a.6.6,0,0,1-.871.615l-7.961-4.147a.6.6,0,0,0-.554,0L6.762,29.462a.6.6,0,0,1-.871-.615l1.3-9.327a.6.6,0,0,0-.155-.492L.749,12.265a.6.6,0,0,1,.334-1L9.9,9.69a.6.6,0,0,0,.432-.323Z",
    transform: "translate(0 2380)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_26",
    "data-name": "Polygon 26",
    d: "M15.115,1.01a.6.6,0,0,1,1.062,0l4.338,8.25a.6.6,0,0,0,.431.312l9.214,1.559a.6.6,0,0,1,.328,1.012L23.957,18.8a.6.6,0,0,0-.165.508l1.358,9.209a.6.6,0,0,1-.859.626L15.912,25a.6.6,0,0,0-.531,0L7,29.14a.6.6,0,0,1-.859-.626L7.5,19.305a.6.6,0,0,0-.165-.508L.805,12.144a.6.6,0,0,1,.328-1.012l9.214-1.559a.6.6,0,0,0,.431-.312Z",
    transform: "translate(39.852 2380)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_27",
    "data-name": "Polygon 27",
    d: "M14.7,1.043a.6.6,0,0,1,1.068,0l4.2,8.213a.6.6,0,0,0,.431.318l8.957,1.557a.6.6,0,0,1,.331,1.006L23.325,18.8a.6.6,0,0,0-.16.5l1.322,9.2a.6.6,0,0,1-.865.62l-8.115-4.114a.6.6,0,0,0-.543,0L6.848,29.124a.6.6,0,0,1-.865-.62l1.322-9.2a.6.6,0,0,0-.16-.5L.777,12.137a.6.6,0,0,1,.331-1.006l8.957-1.557a.6.6,0,0,0,.431-.318Z",
    transform: "translate(80.514 2380)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_28",
    "data-name": "Polygon 28",
    d: "M15.115,1.01a.6.6,0,0,1,1.062,0l4.338,8.25a.6.6,0,0,0,.431.312l9.214,1.559a.6.6,0,0,1,.328,1.012L23.957,18.8a.6.6,0,0,0-.165.508l1.358,9.209a.6.6,0,0,1-.859.626L15.912,25a.6.6,0,0,0-.531,0L7,29.14a.6.6,0,0,1-.859-.626L7.5,19.305a.6.6,0,0,0-.165-.508L.805,12.144a.6.6,0,0,1,.328-1.012l9.214-1.559a.6.6,0,0,0,.431-.312Z",
    transform: "translate(120.353 2380)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_29",
    "data-name": "Polygon 29",
    d: "M14.7,1.043a.6.6,0,0,1,1.068,0l4.2,8.213a.6.6,0,0,0,.431.318l8.957,1.557a.6.6,0,0,1,.331,1.006L23.325,18.8a.6.6,0,0,0-.16.5l1.322,9.2a.6.6,0,0,1-.865.62l-8.115-4.114a.6.6,0,0,0-.543,0L6.848,29.124a.6.6,0,0,1-.865-.62l1.322-9.2a.6.6,0,0,0-.16-.5L.777,12.137a.6.6,0,0,1,.331-1.006l8.957-1.557a.6.6,0,0,0,.431-.318Z",
    transform: "translate(161.027 2380)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIStarsWhite);
export default __webpack_public_path__ + "static/media/i-stars-white.2707a0aa09aa805103cf317685330352.svg";
export { ForwardRef as ReactComponent };